import React from "react"
import type { CupomEstabelecimentoFornecedorModel, CupomItem } from "../models/cupomEstabelecimentoFornecedorModel"
import { CupomEstabelecimentoFornecedorInicial } from "../models/cupomEstabelecimentoFornecedorModel"
import type { CupomEstabelecimentoFornecedorActionModel } from "./cupomEstabelecimentoFornecedorActions"

interface CupomEstabelecimentoFornecedorContextValue {
    dados: CupomEstabelecimentoFornecedorModel
    dispatch: React.Dispatch<CupomEstabelecimentoFornecedorActionModel>
    salvarCupom: (cupom: CupomItem) => Promise<CupomItem>
    excluirCupom: (cupom: CupomItem) => Promise<void>
    erroCarregamento: string | null
}

export const CupomEstabelecimentoFornecedorContext =
    React.createContext<CupomEstabelecimentoFornecedorContextValue>({
        dados: CupomEstabelecimentoFornecedorInicial,
        dispatch: () => undefined,
        salvarCupom: async cupom => cupom,
        excluirCupom: async () => undefined,
        erroCarregamento: null,
    })
